import React, { useState, useEffect, useContext, useRef } from 'react';
import AgeVerification from '../../../../pages/AgeVerification';
import apiService from '../../../../utils/apiService';
import InProgressScreen from '../status-screens/InProgressScreen';
import SuccessScreen from '../status-screens/SuccessScreen';
import YoungScreen from '../status-screens/YoungScreen';
import NotRealScreen from '../status-screens/NotRealScreen';
import ErrorScreen from '../status-screens/ErrorScreen';
import { DataLayerEventContext } from '../../../../contexts/dataLayerEventContext';

const FaceCaptureScreen = ({
  setScreenNumber,
  isDarkMode = true,
  isWithoutRegistration = false,
  handleRedirectToChildren = null
}) => {
  const { sendEvent } = useContext(DataLayerEventContext);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isYoung, setIsYoung] = useState(false);
  const [isNotReal, setIsNotReal] = useState(false);
  const [isInProgress, setInProgress] = useState(false);
  const [showPreCameraModal, setShowPreCameraModal] = useState(false);
  const isMountedRef = useRef(true);
  const timersRef = useRef([]);

  useEffect(() => {
    if (showPreCameraModal) {
      const timer = setTimeout(() => {
        if (isMountedRef.current) {
          setShowPreCameraModal(false);
        }
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [showPreCameraModal]);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
      timersRef.current.forEach((timer) => clearTimeout(timer));
      timersRef.current = [];
    };
  }, []);

  const handleSignatureReceived = async (data) => {
    if (!isMountedRef.current) return;

    setInProgress(true);

    try {
      const user = JSON.parse(localStorage.getItem('user'));

      const payload = {
        signature: data?.signature,
        image: data?.image,
        userId: user?.id,
        version: data?.version,
        token: data?.token,
        verification: data?.verification
      };

      const response = await apiService.post('test/registration/age/verify', {
        data: payload,
        headers: {
          'Content-Type': 'application/json'
        }
      });

      const timer1 = setTimeout(() => {
        if (!isMountedRef.current) return;

        setInProgress(false);

        localStorage.getItem('user');

        const { CDA_Status } = response?.data?.user;

        if (
          response?.data?.verificationResult?.data?.toLowerCase() === 'verified'
        ) {
          sendEvent('verification_success');
          sessionStorage.setItem('verification_success', 'true');
          setIsSuccess(true);

          const timer2 = setTimeout(() => {
            if (!isMountedRef.current) return;

            setIsSuccess(false);

            if (isWithoutRegistration && handleRedirectToChildren) {
              handleRedirectToChildren();
              return;
            }

            if (!CDA_Status) setScreenNumber(8);
          }, 2000);
          timersRef.current.push(timer2);
        } else if (!response?.data?.verificationResult?.error?.success) {
          sendEvent('age_verification_fail');
          setIsNotReal(true);
          const timer4 = setTimeout(() => {
            if (!isMountedRef.current) return;

            setIsNotReal(false);
            setScreenNumber(11);
          }, 2000);
          timersRef.current.push(timer4);
        } else {
          sendEvent('age_verification_fail');
          setScreenNumber(11);
        }
      }, 2000);
      timersRef.current.push(timer1);
    } catch (e) {
      const timer5 = setTimeout(() => {
        if (!isMountedRef.current) return;

        sendEvent('age_verification_fail');
        setInProgress(false);
        setIsError(true);
        const timer6 = setTimeout(() => {
          if (!isMountedRef.current) return;

          setIsError(false);
          setScreenNumber(11);
        }, 2000);
        timersRef.current.push(timer6);
      }, 2000);
      timersRef.current.push(timer5);
    }
  };

  if (isInProgress) {
    return <InProgressScreen />;
  }

  if (isSuccess) {
    return <SuccessScreen />;
  }

  if (isYoung) {
    return <YoungScreen />;
  }

  if (isNotReal) {
    return <NotRealScreen />;
  }

  if (isError) {
    return <ErrorScreen />;
  }

  // if (showPreCameraModal) {
  //   return (
  //     <div
  //       className={styles.modal}
  //       style={{
  //         backgroundImage: `url("${getImageFromS3(
  //           'images/ua-brand/before-camera-modal-bg.png'
  //         )}")`
  //       }}
  //     >
  //       <img
  //         src={getImageFromS3('images/ua-brand/before-camera-modal.png')}
  //         alt="modal-image"
  //         className={styles.modalImage}
  //       />
  //     </div>
  //   );
  // }

  return (
    <AgeVerification
      isDarkMode={isDarkMode}
      onSignatureReceived={handleSignatureReceived}
      onError={() => setScreenNumber(7)}
    />
  );
};

export default FaceCaptureScreen;
